import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Tabs,  } from "antd";
import { Link,  } from "react-router-dom";
import {LazyLoadImage,trackWindowScroll,} from "react-lazy-load-image-component";
//import "react-lazy-load-image-component/src/effects/blur.css";
import {serviceId,Loader} from "../../utils/constant";
import { postRequest } from "../../lib/lib";
import { toast } from "react-toastify";
import  "../Css/style.css";
import { useTranslation } from "react-i18next";



const GameCollection = ({ category, games, msisdn, scrollPosition }) => {
  const { TabPane } = Tabs;
  const [filteredCat, setFilteredCat] = useState([]);
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState({message: "",error: false});
  const { t } = useTranslation("global");

  const onChange = (key) => {
    setFilteredCat(category.filter((item) => item.sub_cat_id === key));
  };
  useEffect(() => {
    setFilteredCat(category);    
  }, [category]);

  const unsub = async() => {
      setLoader(true);
      const [e1, data] = await postRequest("ocmKm",{action:2,serviceId:serviceId,mode:"WAP"});    
      setLoader(false); 
      if(data !=null) 
      {        
        //setMessage({message:"You are successfully unsubscribed from the service",error:false});
        //toast.info("You have successfully unsubscribed from the service");
        localStorage.clear();
        window.location.href="/success";
      }
      else {
        if(e1.response.data)return toast.info(e1.response.data.message);
      }        
    }; 

  return (
    <VideoCollectionStyled>
      <Tabs
        defaultActiveKey="50"
        centered
        onChange={onChange}
        style={{ color: "white", padding: "10px", fontFamily: "monospace", fontSize: "16px" }}
      > 
        <TabPane tab={t("portalText.All")} key="50">
          {category.map((catitem) => (
            <div className="section-collection" key={catitem.id}>
              <h3>{t("portalText."+catitem.name)}</h3>
              <div className="game-collection">
                {games.map((item) => {
                  if (item.category === catitem.name)
                    return (
                      <div className="card-item" key={item.id}>
                        <Link to={`/video/${item.id}`}>
                          <div className="overlay-buttons" >
                            <div className="box">{t("portalText.playNow")}</div>
                          </div>
                          <LazyLoadImage
                            // style={contentStyle}
                            width='100%'
                            src={item.imageUrl}
                            alt={item.name}
                            effect=""
                            scrollPosition={scrollPosition}
                          />
                        </Link>
                        {/* <p style={{ color: "white", padding: "5px"}}>{item.name}</p> */}
                      </div>
                    );
                })}
              </div>
            </div>
          ))}
        </TabPane>

        {category.map((item) => (
          <TabPane tab={t("portalText."+item.name)} key={item.sub_cat_id}>
            {filteredCat.map((catitem) => (
              <div className="section-collection" key={catitem.sub_cat_id}>
                <h3>{t("portalText."+catitem.name)}</h3>
                <div className="game-collection">
                  {games.map((item) => {
                    if (item.category === catitem.name)
                      return (
                        <div className="card-item" key={item.id}>
                          <Link to={`/video/${item.id}`}>
                            <div className="overlay-buttons">
                              <div className="box">{t("portalText.playNow")}</div>
                            </div>
                            <LazyLoadImage
                              // style={contentStyle}
                              width='100%'
                              src={item.imageUrl}
                              alt={item.name}
                              effect="blur"
                              scrollPosition={scrollPosition}
                            />
                          </Link>
                          {/* <p style={{ color: "white", padding: "5px"}}>{item.name}</p> */}
                        </div>
                      );
                  })}
                </div>
              </div>
            ))}
          </TabPane>
        ))}
         {token &&
          <TabPane tab={"Unsub"} key={"unsub"}>
                <div className="section-collection" key="unsub102">
                   <SubInfo key={"unsubInfo"} >  
                   {message.message?
                      <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p></div>
                      :
                      <>
                      <div className="pack-select">
                        <h2>{t("portalText.Unsub Desc")}</h2>
                      </div>
                      {loader ?<Loader />:
                          <PrimaryButton
                            disabled={loader}
                            size="large"
                            color="green"
                            name="confirm"
                            onClick={unsub}
                            type="primary"
                          > {t("portalText.Unsub")} </PrimaryButton>
                      }
                      </>
                    }
                    </SubInfo> 
                </div>
            </TabPane>
        }
      </Tabs>
    </VideoCollectionStyled>
  );
};

export default trackWindowScroll(GameCollection);

const VideoCollectionStyled = styled.div`
  min-height: 100vh;
  h3 {
    width: 200px;
    font-size: 19px;
    text-align: center;
    color: white !important;
    padding: 10px;
    font-family: monospace;
    background-color: #ef473a;
    border-radius: 8px;
    cursor: pointer;
    @media (min-width: 768px) {
      width: 80%;
      text-align: start;
    }
  }
  
`;


const SubInfo = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  justify-content: center;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(2.1px);
  border: 1px solid rgba(255, 255, 255, 0.09);
  width: 100%;
  h2 {
    color: #05C3DD;
    font-style: normal;
    font-weight: 700;
    font-size: 1.5rem;
    font-family: "Concert One", "Pacifico";
  }
  h3 {
    color: #f46b45;
    font-style: normal;
    font-weight: 700;
    font-size: 2rem;
    font-family: 'Skranji', "Concert One";
  }
  .select {
    width: 300px;
    font-family: Teko, robot;
    font-family: 700;
    color: grey;
    text-align: center;
  }
  .pack-select {
    display: grid;
    grid-template-rows: row row;
    grid-gap: 10px;
    margin: 10px;
  }
  .checkbox {
    color: #05C3DD;
    font-family: "Concert One", cursive;
    margin: 5px;
  }
  @media screen and (max-width: 768px) {
    h2 {
      text-align: center;
      font-size: 19px;
    }
    .select {
      width: 100%;
    }
  }
`;

const PrimaryButton = styled.button`
  background-color: #05C3DD;
  color: white;
  padding: 7px;
  width: 100%;
  margin: 15px 0;
  border: none;
  outline: none;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Concert One", Times, serif;
  letter-spacing: 4px;
  font-weight: 700;
  :hover {
    background-color: black;
    color: #fff;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

